module.exports = __webpack_public_path__ + "img/70.a4e7db94.jpg";